// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2LrTA","info":"PatientInfo_info__25lHN"};